import Page from "./page";
import { useTranslation } from "react-i18next";
import qrcode from '../../assets/software/qrcodeOrange.png';
import Pic1 from '../../assets/software/self/1.png';
import Pic2 from '../../assets/software/self/2.png';
import logo1 from '../../assets/software/self/logo1.png';
import logo2 from '../../assets/software/self/logo2.png';
import selfPic from '../../assets/software/self/self.png';
import u1 from "../../assets/software/u1.png";
import u2 from "../../assets/software/u2.png";
import u3 from "../../assets/software/self/u3.png";
import u4 from "../../assets/software/self/u4.png";
function Selfhelp() {
  let { t } = useTranslation();

  const datas = [
    {
      pic: Pic1,
      logo: logo1,
      title: t("selfType.reportTitle"),
      infos: [
        t("selfType.reportInfo1"),
        t("selfType.reportInfo2"),
        t("selfType.reportInfo3"),
        t("selfType.reportInfo4"),
      ],
      bgcolor: "rgb(255,248,240)",
    },
    {
      pic: Pic2,
      logo: logo2,
      title: t("selfType.goodsTitle"),
      infos: [
        t("selfType.goodsInfo1"),
        t("selfType.goodsInfo2"),
        t("selfType.goodsInfo3"),
      ],
    }
  ]
  return (
    <Page
      {...{
        title: t("selfType.title"),
        content: t("selfType.info"),
        pic: selfPic,
        bgColor: "rgba(255, 142, 43, 1)",
        linearGradient: 'linear-gradient(161.37deg, rgba(255, 106, 0, 1) 0%, rgba(255, 153, 64, 1) 100%)',
        downInfo: {
          bgColor: "#ff8122",
          qrBgColor: '#ffebd1',
          qrcode: qrcode,
          showMac: false,
          showWin: false,
          urlName: 'toposify_orderbyself',
          url1: "https://play.google.com/store/apps/details?id=com.htsd.toposify_self_ordert",
          url2: "https://itunes.apple.com/app/?",
          u1: u1,
          u2: u2,
          u3: u3,
          u4: u4,
          showWin: false
        },
        bodyDatas: datas,
        textColor: '#fff'
      }}
    />
  );
}

export default Selfhelp;

